import { useQuery, UseQueryOptions } from 'react-query'
import { AxiosError } from 'axios'

import {
  GETOAuthSchemaQueryStringParams,
  GETOAuthSchemaResponse,
  mutateGetOAuthSchemaResponse
} from 'api/types'
import { QueryKey } from 'constants/endpoint'
import { useClient } from './useClient'
import { getOAuthSchema } from 'api/clients'

type TData = GETOAuthSchemaResponse
type TError = AxiosError<unknown>

export const useGetOAuthSchema = (
  params: GETOAuthSchemaQueryStringParams,
  options?: UseQueryOptions<TData, TError>
) => {
  const client = useClient()
  const { projectId, agentId } = params

  return useQuery<TData, TError>(
    [QueryKey.OAUTH_SCHEMA, projectId, agentId],
    async () => {
      const schema: GETOAuthSchemaResponse = await getOAuthSchema(
        params,
        client
      )
      return mutateGetOAuthSchemaResponse(schema)
    },
    options
  )
}
